$(window).scroll(function() {
  var scroll = $(window).scrollTop();
	$(".home-bg-img").css({
		backgroundSize: "auto " + (150 + scroll/15)  + "%",
		top: -(scroll/10)  + "%",

	});
});


if ( $( window ).width() < 768 ) {
  $(window).scroll(function() {
    var scroll = $(window).scrollTop();
      $(".home-bg-img").css({
          backgroundSize: "auto " + (100 + scroll/15)  + "%",
          top: -(scroll/10)  + "%",
      });
  });
}
$( window ).resize( function() {
  if( $( window ).width() < 768) {
    $(window).scroll(function() {
      var scroll = $(window).scrollTop();
        $(".home-bg-img").css({
            backgroundSize: "auto " + (100 + scroll/15)  + "%",
            top: -(scroll/10)  + "%",
        });
    });
  }
});